/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:08
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace MaintenanceRecordDOI {
    export interface RowDataI {
        dispose_content: string;
        dispose_datetime: string;
        dispose_people: string;
        dispose_site: string;
        dispose_type: string;
        id: number;
        record_number: string;
        accessory:string;
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        dispose_type?: Integer;
        end_time?: Integer;
        start_time?: Integer;
    }

    export interface QueryDetailResultI {
        accessory: string
        dispose_content: string
        dispose_datetime: string
        dispose_name: string
        dispose_people: string
        dispose_site: number
        dispose_type: string
        dispose_type_id: number
    }

    export interface OperateParamsI {
        id?: Integer;
        accessory: string;
        dispose_site: Integer;
        dispose_type: Integer;
        dispose_people: string;
        dispose_datetime: string;
        dispose_content: string;
    }
}
export default class MaintenanceRecordApi {
    /**
     * 查询列表
     * @param {MaintenanceRecordDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: MaintenanceRecordDOI.QueryRowDataParamsI): Promise<ResultPageDo<MaintenanceRecordDOI.RowDataI[]>> {
        return Api.post('/ops/dispose_record/list/get', {
            dispose_type: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<MaintenanceRecordDOI.QueryDetailResultI>> {
        return Api.post('/ops/dispose_record/particulars/get', params);
    }
    /**
     * 新增
     * @param {MaintenanceRecordDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: MaintenanceRecordDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/dispose_record/add', data);
    }

    /**
     * 修改
     * @param {MaintenanceRecordDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: MaintenanceRecordDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/dispose_record/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/ops/dispose_record/batch/delete', data);
    }
}
